module.exports = "/_next/static/images/3135ea3d419e825551baf77ae37982d7-pregnant-woman@mobile@1x.jpg";